export const SET_PORTAL_ERROR = 'SET_PORTAL_ERROR';
export const SET_PORTAL_INFO_FORM = 'SET_PORTAL_INFO_FORM';
